import { render } from "./LinePointMarker.vue?vue&type=template&id=62085f5a&ts=true"
import script from "./LinePointMarker.vue?vue&type=script&lang=ts"
export * from "./LinePointMarker.vue?vue&type=script&lang=ts"

import exportComponent from "E:\\Code\\Github\\Wuguojie-AviationTeach\\AviationTeach-PPT\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__